"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var utilities_1 = require("../utilities");
/**
 * Determines if the selected programs in the form state are empty
 * @param selectedPrograms the current value of the selected programs in the form state
 * @returns true if the given value should be considered empty
 */
function hasEmptyProgramValue(selectedPrograms) {
    return !selectedPrograms || (immutable_1.List.isList(selectedPrograms) && selectedPrograms.size === 0);
}
exports.hasEmptyProgramValue = hasEmptyProgramValue;
/**
 * determines if a program name contains some text
 * @param selectedPrograms the current value of the selected programs in the form state
 * @param allPrograms information on all programs, used to determine the names of the selected programs
 * @param conditionValue text string to match
 */
function programNameContains(selectedPrograms, allPrograms, conditionValue) {
    var conditionStr = conditionValue.trim().toLocaleUpperCase();
    // regex format
    conditionStr = utilities_1.textUtilities.convertStrToRegExStr(conditionStr);
    // account for wildcard with regex symbol for wildcard
    conditionStr = conditionStr.replace(RegExp("%", "g"), ".*");
    var conditionRegex = RegExp(conditionStr);
    var programs = allPrograms ? allPrograms.toArray() : [];
    var selectedProgramNames = selectedPrograms ? programs.filter(function (program) { return selectedPrograms.includes(program.id); }).map(function (program) { return program.name; }) : [];
    return !!selectedProgramNames && !!conditionRegex && selectedProgramNames.some(function (name) { return conditionRegex.test(name.trim().toLocaleUpperCase()); });
}
exports.programNameContains = programNameContains;
/**
 * Determines if any of the programs in the condition value have been selected
 * @param selectedPrograms the current value of the selected programs in the form state
 * @param conditionValue array of program ids to match
 */
function programAnySelected(selectedPrograms, conditionValue) {
    return !!selectedPrograms && !!conditionValue && conditionValue.some(function (programId) { return selectedPrograms.includes(programId); });
}
exports.programAnySelected = programAnySelected;
/**
 * Determines if all of the programs in the condition value have been selected
 * @param selectedPrograms the current value of the selected programs in the form state
 * @param conditionValue array of program ids to match
 */
function programAllSelected(selectedPrograms, conditionValue) {
    return !!selectedPrograms && (!conditionValue || conditionValue.every(function (programId) { return selectedPrograms.includes(programId); }));
}
exports.programAllSelected = programAllSelected;
//# sourceMappingURL=program-operators.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/rules-engine/program-operators.js
// module id = 1162
// module chunks = 0